import { useMemo, useRef } from 'react';

import { twMerge } from 'tailwind-merge';

import { useScrollText } from '../../hooks/useScrollText';
import { ValueComponentProps } from './Dropdown';
import { DropdownExpandMoreIcon } from './DropdownExpandMoreIcon';

export function DefaultDropdownValue({
  placeholder,
  value,
  multiple,
  open,
  isError,
  disabled,
  className,
  wrapperClassName,
  icon,
}: ValueComponentProps) {
  const buttonLabel = useMemo(() => {
    if (multiple && Array.isArray(value)) {
      return value.map((option) => option.label).join(', ');
    }
    return value?.label || '';
  }, [multiple, value]);

  const textBoxRef = useRef<HTMLDivElement>(null);
  const triggerBoxRef = useRef<HTMLDivElement>(null);

  useScrollText(textBoxRef, triggerBoxRef);

  return (
    <div
      ref={triggerBoxRef}
      className={twMerge(
        'group font-inter text-v2blueGray-800 border cursor-pointer w-full flex gap-2 border-v2blueGray-0 bg-v2blueGray-0 hover:bg-v2blueGray-100 justify-between rounded-lg pl-4 pr-2 h-9 text-sm items-center transition-colors',
        open && 'bg-v2blueGray-100',
        isError && 'border-v2red',
        wrapperClassName,
        disabled &&
          'text-v2blueGray-400 cursor-not-allowed bg-transparent hover:bg-transparent border-v2blueGray-200',
      )}
    >
      {icon && icon}
      {!icon && <>{!!value?.icon && value.icon}</>}

      <div className="flex-1 min-w-0 text-left">
        <div
          ref={textBoxRef}
          className={twMerge(
            'h-full block truncate text-v2blueGray-800 ',
            (!buttonLabel || disabled) && 'text-v2blueGray-400',
            className,
          )}
        >
          <span className="group-hover:inline-block">{buttonLabel || placeholder}</span>
        </div>
      </div>
      <DropdownExpandMoreIcon open={open} />
    </div>
  );
}
